import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'

import ContextProvider from '~/provider/ContextProvider'

import { GlobalStyle, sizes } from '~/utils/styles'
import Navigation from '~/components/Navigation'
import Footer from '../components/Footer/'

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: ${sizes.pageWidth};
  padding: 0px 1.0875rem 1.45rem;
  min-height: calc(100vh - 50px);
  box-sizing: border-box;
`

const Layout = ({ children }) => {
  return (
    <ContextProvider>
      <GlobalStyle />
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Wrapper>
              <Navigation siteTitle={data.site.siteMetadata.title} />
              {children}
            </Wrapper>
            <footer
              style={{ maxWidth: '1200px', height: '50px', margin: 'auto' }}
            >
              © {new Date().getFullYear()}, Design by
              {` `}
              <a href="https://www.gabrieldavsion.com">Gabriel Davison</a>
            </footer>
          </>
        )}
      />
    </ContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
